export enum EXPANDS {
    NotificationHeader = '$expand=TaskSet,AddressSet,CodeSet,ContractSet,DopSet,EmailSet,EquipmentsSet,HistorySet,PartSet,ParticipantSet,HotsiteLtextSet,NotifLtextSet,ObjInfLtextSet,PreClLtextSet,HistoryLtextSet,IntInfLtextSet,RentLtextSet,TaxiLtextSet',
    MaterialStockAvailability = '$expand=MatStockAvailability,MatStockLtext',
    WorkSchedule = '$expand=ScheduleSet',
    CseStock = '$expand=CSEStockAvailability',
    ExpandEntitySourceReplacement = 'SorcLTextSet',
    ExpandEntityPaperwork = 'PaperWorkSet',
    ExpandEntityPhysicalInventory = '$expand=PIToolsSet,SparePartsSet',
}
